import React, { useLayoutEffect } from 'react';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import ModuleList from '../../../layout/ModuleList';
import {
  clearSalesTaxes,
  getSalesTaxes,
} from '../../../../actions/accounting/SalesTax';
import { SALES_TAX_PATH, NEW_SALES_TAX_PATH } from '../../../../config/paths';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import { SALES_TAX_COLUMNS } from '../../../../config/columns';

export const SalesTaxes = ({
  breadcrumbs,
  salesTaxes,
  loading,
  dispatchGetSalesTaxes,
  dispatchClearSalesTaxes,
}) => {
  useLayoutEffect(
    () => () => {
      dispatchClearSalesTaxes();
    },
    [],
  );

  const data = salesTaxes.get('content') || [];
  const pages = salesTaxes.get('totalPages') || null;
  const defaultPageSize = salesTaxes.get('size') || DEFAULT_PAGE_SIZE;

  return (
    <ModuleList
      title="Impuestos a la Venta"
      buttonPath={NEW_SALES_TAX_PATH}
      breadcrumbs={breadcrumbs}
      tableStructure={{
        columns: SALES_TAX_COLUMNS,
        data,
        pages,
        defaultPageSize,
        filterable: true,
        fetchData: dispatchGetSalesTaxes,
        loading,
        modelPath: SALES_TAX_PATH,
        navigateToModelOnRowClick: true,
      }}
    />
  );
};

const mapDispatchToProps = {
  dispatchGetSalesTaxes: getSalesTaxes,
  dispatchClearSalesTaxes: clearSalesTaxes,
};

const mapStateToProps = ({ AccountingUnit }) => ({
  breadcrumbs: [
    ...AccountingUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Impuestos a la Venta',
      href: SALES_TAX_PATH,
    },
  ],
  salesTaxes: AccountingUnit.SalesTax.getIn(['all', 'content']),
  loading: AccountingUnit.SalesTax.getIn(['all', 'loading']),
});

SalesTaxes.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  salesTaxes: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetSalesTaxes: PropTypes.func.isRequired,
  dispatchClearSalesTaxes: PropTypes.func.isRequired,
};

SalesTaxes.defaultProps = {
  salesTaxes: [],
  loading: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(SalesTaxes);
